import {Component, Input, Output, EventEmitter} from '@angular/core';


@Component({
    selector: 'app-step-indicator',
    templateUrl: './step-indicator.component.html',
    imports: [],
    styleUrls: ['./step-indicator.component.css']
})
export class StepIndicatorComponent {
  $currentPage = 1;

  @Input()
  set currentPage(i: number) {
    this.maxPage = Math.max(this.maxPage, i);
    this.$currentPage = i;
  }

  @Input()
  indicators: string[];
  @Output()
  currentPageChange = new EventEmitter<number>();
  maxPage = 1;

  setPage(i: number): void {
    this.maxPage = Math.max(this.maxPage, i);
    this.$currentPage = i;
    this.currentPageChange.emit(this.$currentPage);
  }

}
